export default __webpack_public_path__ + "409484d2c346ec0c07d3204b8ac7e87c.png";